import React from "react";
import { Routes, Route } from "react-router-dom";
import { Carteiras, CarteirasAdd, CarteirasEdit } from "../../../pages";
import CarteirasProvider from "../../../contexts/CarteirasContext";

const CarteirasRoutes = () => {
  return (
    <CarteirasProvider>
      <Routes>
        <Route path={`:id`} element={<CarteirasEdit />} />
        <Route path={`add`} element={<CarteirasAdd />} />
        <Route path="" element={<Carteiras />} />
      </Routes>
    </CarteirasProvider>
  );
};

export default CarteirasRoutes;
